/* Skelner mellem en crawler/prerender og en rigtig browser, så et hængende API-kald
   aldrig kan forsinke den HTML, en bot får. Crawlere får en stram timeout, rigtige
   brugere får længere tid, så de også får indholdet på et dårligt mobilnet. */

const BOT_UA =
  /bot\b|crawler|spider|crawl|chatgpt|gptbot|oai-searchbot|searchgpt|perplexity|claudebot|anthropic|applebot|bingbot|googlebot|google-extended|duckduckbot|baiduspider|yandex|slurp|facebookexternalhit|meta-externalagent|twitterbot|linkedinbot|slackbot|discordbot|telegrambot|whatsapp|ccbot|bytespider|amazonbot|headless|lighthouse|pagespeed|prerender|phantomjs|puppeteer/i;

export const isCrawler = () => {
  if (typeof navigator === "undefined") return true;
  return BOT_UA.test(navigator.userAgent || "");
};

/** Timeout til ikke-kritiske GET-kald på de offentlige sider. */
export const API_TIMEOUT = isCrawler() ? 1500 : 4000;
